module.exports = __webpack_public_path__ + "img/FULL.dd30523a.png";